import { scoreHelper } from "../../../../../helpers";
import { renderMiniScore } from "./renderMiniScore";
export var renderMiniLiveScore = function (event) {
    var score = scoreHelper(event);
    return renderMiniScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard);
};
//# sourceMappingURL=renderMiniLiveScore.js.map